export default __webpack_public_path__ + "static/media/20.1b3de9fe.png";